// extracted by mini-css-extract-plugin
module.exports = {"title":"InfoCell_title__DIs4V","text":"InfoCell_text__1Mu14","additionalText":"InfoCell_additionalText__2PJyr"};